import { render } from "./ProjectsGallery.vue?vue&type=template&id=2543ccb8&scoped=true"
import script from "./ProjectsGallery.vue?vue&type=script&lang=js"
export * from "./ProjectsGallery.vue?vue&type=script&lang=js"

import "./ProjectsGallery.vue?vue&type=style&index=0&id=2543ccb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2543ccb8"]])

export default __exports__